import styles from './Tab.module.scss';

export interface TabProps {
  /** Tab label text */
  label: string;

  /** Whether the tab is active */
  active?: boolean;

  /** Click handler */
  onClick?: () => void;

  /** Disabled state */
  disabled?: boolean;
}

export const Tab = ({
  label,
  active = false,
  onClick,
  disabled = false,
}: TabProps) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const tabClassName = [
    styles.tab,
    active ? styles.active : styles.inactive,
    disabled && styles.disabled,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={tabClassName}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="tab"
      aria-selected={active}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      type="button"
    >
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export interface TabGroupProps {
  /** Tab children */
  children: React.ReactNode;

  /** Additional CSS classes */
  className?: string;
}

export const TabGroup = ({ children, className = '' }: TabGroupProps) => {
  const groupClassName = [styles.group, className].filter(Boolean).join(' ');

  return (
    <div className={groupClassName} role="tablist">
      {children}
    </div>
  );
};
